import React from "react";
import { StyledSpace, StyledSpaceItem } from "./CommonStyles";

const Space = ({ size = 8, children }) => {
  return (
    <StyledSpace size={size}>
      {React.Children.map(children, (child) => (
        <StyledSpaceItem size={size}>{child}</StyledSpaceItem>
      ))}
    </StyledSpace>
  );
};

export default Space;